module.exports = __webpack_public_path__ + "static/distanz-fb5691b6cf68adfde184921ab8d083b7.png";